import { Injectable } from '@angular/core';
import { ICostingLevel } from '../models/costing-level.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';

const BASE_URL: string = 'costing-level';

@Injectable({
    providedIn: 'root'
})
export class CostingLevelResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getAllCostingLevels(): Observable<ICostingLevel[]> {
        return this.myCostAccountingRequestService.get(BASE_URL);
    }

    public addCostingLevel(costingLevel: ICostingLevel): Observable<ICostingLevel>{
        return this.myCostAccountingRequestService.post(BASE_URL, costingLevel);
    }

    public updateCostingLevel(costingLevel: ICostingLevel): Observable<ICostingLevel>{
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${costingLevel.id}`, costingLevel);
    }

    public deleteCostingLevel(costingLevelId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${costingLevelId}`);
    }
}
